<template>
  <div id="ticketpage">
 
    <!-- ======================== 페이지 히어로 ======================== -->
    <div class="tp-hero">
      <div class="tp-hero-bg"></div>
      <div class="tp-hero-dots"></div>
      <div class="container">
        <div class="tp-hero-inner">
          <div class="tp-hero-tag">🎫 NTABI TRAVEL STORE</div>
          <h1 class="tp-hero-title">티켓 &amp; 패스</h1>
          <p class="tp-hero-sub">여행을 더 자유롭게, 더 알차게!</p>
          <div class="tp-hero-chips">
            <a href="#sec-jp" class="tp-chip tp-chip-jp" @click.prevent="goToSection('sec-jp')"><i class="bi bi-circle-fill text-danger"></i> 일본</a>
            <a href="#sec-etc" class="tp-chip tp-chip-etc" @click.prevent="goToSection('sec-etc')">🌏 나라별</a>
          </div>
        </div>
      </div>
      <div class="tp-hero-wave">
        <svg viewBox="0 0 1440 80" xmlns="http://www.w3.org/2000/svg" preserveAspectRatio="none">
          <path d="M0,40 C180,80 360,0 540,40 C720,80 900,0 1080,40 C1260,80 1380,20 1440,40 L1440,80 L0,80 Z" fill="#fefdf8"/>
        </svg>
      </div>
    </div>
 
    <section class="ticketpass section">
 
      <!-- ======================== 일본 티켓·패스 ======================== -->
      <div id="sec-jp" class="container tp-section">
        <div class="tp-section-header">
          <div class="tp-section-badge pass-badge" style="vertical-align: top;">JAPAN</div>&nbsp;
          <h3 class="tp-section-title">일본 티켓·패스</h3>
          <p class="tp-section-sub">일본 여행의 필수템, 한 곳에서 간편하게!</p>
        </div>
 
        <!-- 카테고리 필터 -->
        <div class="category" id="jp">
          <ul :key="ntCd" v-for="(jp, ntCd) in this.ntToAr_jp">
            <li class="fingerPointer" @click="showJpSelArea('jpAll')">
              <a href="javascript:void(0)">전체</a>
            </li>
            <li :key="ar.arCd" v-for="ar in jp" class="fingerPointer" @click="showJpSelArea(ar.arCd)">
              <a href="javascript:void(0)">{{ ar.AR }}</a>
            </li>
          </ul>
        </div>
 
        <div class="row gx-3 gy-3">
          <div class="col-xl-3 col-lg-4 col-6" :key="i" v-for="(nd, i) in this.ndaytirpList_jp">
            <a class="tp-card-link" @click="goToDetail(nd.pdtCode, nd.salesRoute)" href="javascript:void(0)">
              <div class="tp-card">
                <div class="tp-card-stub">
                  <span class="stub-text">ADMIT ONE</span>
                  <span class="stub-dots">· · · · · · · · ·</span>
                </div>
                <div class="tp-card-img-wrap">
                  <div class="tp-card-hover"><span>자세히 보기 →</span></div>
                  <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="tp-card-img" alt="..." />
                  <img v-else :src="`/download/noImage/noImage.jpg`" class="tp-card-img" />
                  <div class="badge-wrap">
                    <div v-if="nd.badgeFlag === 'Y'">
                      <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                    </div>
                    <div v-if="nd.badge2Flag === 'Y'">
                      <div v-if="nd.badgeFlag != 'Y'" class="badge1">
                        <small class="badge1-text">{{ nd.badge2 }}</small>
                      </div>
                      <div v-else class="badge2">
                        <small class="badge2-text">{{ nd.badge2 }}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tp-card-perf"></div>
                <div class="tp-card-body">
                  <h3 class="tp-card-title">{{ nd.pdtNameKor }}</h3>
                  <p class="tp-card-remarks">{{ nd.pdtRemarks }}</p>
                  <div class="tp-card-price" v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'">
                    <!-- 할인 없음 -->
                    <template v-if="nd.discountPercent == 0">
                      <span class="price-num">{{ getCurrencyFormat(nd.pdtPrice) }}</span>
                      <span class="price-unit">원</span>
                      <span class="price-per">/ 1인</span>
                    </template>
                    <!-- 할인 있음 -->
                    <template v-else>
                      <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                      <span class="price-arrow">›</span>
                      <span class="price-discount">{{ getCurrencyFormat(nd.discountPercent) }}%</span>
                      <span class="price-num">{{ getCurrencyFormat((nd.basic_PdtPrice*1) + (nd.minOptPrice*1)) }}</span>
                      <span class="price-unit">원~</span>
                    </template>
                  </div>
                  <!-- 준비중 -->
                  <div class="preparing-wrap" v-else>
                    <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                    <span class="preparing-text">상품을 준비 중입니다</span>
                    <i class="bi bi-question-circle-fill text-danger ms-1" style="cursor:pointer; font-size:.85rem" @click.stop="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>

        <!-- 더보기 (일본) -->
        <div class="more-wrap more-jp fingerPointer" @click="showJpMoreList()" v-if="this.ndaytirpList_jp_more.length > 0">
          <div class="more-btn" v-if="this.jp_more === 'N'">
            <span>더보기</span> <i class="bi bi-chevron-down"></i>
          </div>
          <div class="more-btn" v-else>
            <span>접기</span> <i class="bi bi-chevron-up"></i>
          </div>
        </div>
      </div>

      <!-- 섹션 구분 배너 -->
      <div class="tp-divider-banner">
        <div class="banner-scroll-text">
          <span>🎟 TICKET &amp; PASS &nbsp;·&nbsp; 🎡 ENJOY TRAVEL &nbsp;·&nbsp; 🚃 FREE PASS &nbsp;·&nbsp; 🎢 THEME PARK &nbsp;·&nbsp; 🗾 JAPAN &nbsp;·&nbsp; 🌏 WORLD &nbsp;·&nbsp;</span>
          <span>🎟 TICKET &amp; PASS &nbsp;·&nbsp; 🎡 ENJOY TRAVEL &nbsp;·&nbsp; 🚃 FREE PASS &nbsp;·&nbsp; 🎢 THEME PARK &nbsp;·&nbsp; 🗾 JAPAN &nbsp;·&nbsp; 🌏 WORLD &nbsp;·&nbsp;</span>
        </div>
      </div>
 
 
      <!-- ======================== 나라별 티켓·패스 ======================== -->
      <div id="sec-etc" class="container tp-section">
        <div class="tp-section-header">
          <div class="tp-section-badge ticket-badge" style="vertical-align: top;">WORLD</div>&nbsp;
          <h3 class="tp-section-title">나라별 티켓·패스</h3>
          <p class="tp-section-sub">세계 각지의 인기 티켓을 만나보세요!</p>
        </div>
 
        <!-- 카테고리 필터 -->
        <div class="category" id="no-jp">
          <ul>
            <li class="fingerPointer" @click="showEtcSelArea('etcAll')">
              <a href="javascript:void(0)">전체</a>
            </li>
            <li :key="ntCd" v-for="(etc, ntCd) in this.ntToAr_etc"
                class="fingerPointer" @click="showEtcSelArea(etc[0].ntCd)">
              <a href="javascript:void(0)">{{ etc[0].NT }}</a>
            </li>
          </ul>
        </div>
 
        <div class="row gx-3 gy-3">
          <div class="col-xl-3 col-lg-4 col-6"
               :key="j" v-for="(nd, j) in this.ndaytirpList_etc">
            <a class="tp-card-link" @click="goToDetail(nd.pdtCode, nd.salesRoute)" href="javascript:void(0)">
              <div class="tp-card tp-card-etc">
                <div class="tp-card-stub stub-etc">
                  <span class="stub-text">ADMIT ONE</span>
                  <span class="stub-dots">· · · · · · · · ·</span>
                </div>
                <div class="tp-card-img-wrap">
                  <div class="tp-card-hover"><span>자세히 보기 →</span></div>
                  <img v-if="nd.imgName != 'noImage'" :src="`/download/${nd.pdtCode}/${nd.imgName}`" class="tp-card-img" alt="..." />
                  <img v-else :src="`/download/noImage/noImage.jpg`" class="tp-card-img" />
                  <div class="badge-wrap">
                    <div v-if="nd.badgeFlag === 'Y'">
                      <div class="badge1"><small class="badge1-text">{{ nd.badge }}</small></div>
                    </div>
                    <div v-if="nd.badge2Flag === 'Y'">
                      <div v-if="nd.badgeFlag != 'Y'" class="badge1">
                        <small class="badge1-text">{{ nd.badge2 }}</small>
                      </div>
                      <div v-else class="badge2">
                        <small class="badge2-text">{{ nd.badge2 }}</small>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tp-card-perf perf-etc"></div>
                <div class="tp-card-body">
                  <h3 class="tp-card-title">{{ nd.pdtNameKor }}</h3>
                  <p class="tp-card-remarks">{{ nd.pdtRemarks }}</p>
                  <div class="tp-card-price" v-if="nd.basic_PdtPrice > 0 && nd.displayFlag == 'Y' && nd.saleFlag == 'Y'">
                    <template v-if="nd.discountPercent == 0">
                      <span class="price-num">{{ getCurrencyFormat(nd.pdtPrice) }}</span>
                      <span class="price-unit">원</span>
                      <span class="price-per">/ 1인</span>
                    </template>
                    <template v-else>
                      <span class="price-original">{{ getCurrencyFormat(nd.pdtPrice) }}원</span>
                      <span class="price-arrow">›</span>
                      <span class="price-discount">{{ getCurrencyFormat(nd.discountPercent) }}%</span>
                      <span class="price-num">{{ getCurrencyFormat((nd.basic_PdtPrice*1) + (nd.minOptPrice*1)) }}</span>
                      <span class="price-unit">원~</span>
                    </template>
                  </div>
                  <div class="preparing-wrap" v-else>
                    <img src="../assets/img/gBus.png" alt="" class="mbus-icon" />
                    <span class="preparing-text">상품을 준비 중입니다</span>
                    <i class="bi bi-question-circle-fill text-danger ms-1" style="cursor:pointer; font-size:.85rem" @click.stop="inquiryProduct(nd.pdtCode, nd.salesRoute)"></i>
                  </div>
                </div>
              </div>
            </a>
          </div>
        </div>
 
        <!-- 더보기 (나라별) -->
        <div class="more-wrap more-etc fingerPointer" @click="showEtcMoreList()" v-if="this.ndaytirpList_etc_more.length > 0">
          <div class="more-btn more-btn-etc" v-if="this.etc_more === 'N'">
            <span>더보기</span> <i class="bi bi-chevron-down"></i>
          </div>
          <div class="more-btn more-btn-etc" v-else>
            <span>접기</span> <i class="bi bi-chevron-up"></i>
          </div>
        </div>
      </div>
 
    </section>
  </div>
</template>

<script>
export default {
  // DB에서 가져온 데이타
  data() {
    return {
      // ntToAr: {},                   //티켓패스 판매가능 국가지역
      ntToAr_jp: [],                //일본내 티켓패스가능지역
      ntToAr_etc: [],               //판매가능 국가와 지역
      nt: "",                       //상품카테고리(국가기준)
      ar: "",                       //상품카테고리(지역기준)

      sellerCode: "NT",             //판매자코드

      productListForSales_org: [],  //로컬전체상품
      productListForSales: [],      //판매상품리스트
      ndaytirpList_jp: [],          //일본내 티켓패스
      ndaytirpList_jp_org: [],
      ndaytirpList_jp_more: [],
      ndaytirpList_etc: [],         //일본외 티켓패스
      ndaytirpList_etc_org: [],
      ndaytirpList_etc_more: [],
      jp_more: "N",                 //일본내 더보기
      etc_more: "N",                //일본외 더보기


      //showLayer: false,           //지역(국가)선택레이어


      natName: "",                      //표시페이지 국가명
      selectableNation: [],             //선택가능 국가

      // n1: "",                        //bannerName1
      // n2: "",                        //bannerName2
      nationList: {},                   //여행지역리스트
      pdtCatList: {},                   //상품카테고리
      
      productListForSales_recomend: {}, //추천상품리스트
    };
  },
  created() {
    // 페이지생성과 동시에 리스트정보를 get
		this.nt = (this.$route.query.nt == undefined) ? "%" : this.$route.query.nt;
    this.ar = (this.$route.query.ar == undefined) ? "%" : this.$route.query.ar;
		this.sellerCode = (this.$route.query.sc === undefined) ? "NT" : this.$route.query.sc;

    // 네이버데이타 호환처리
    this.getProductList_new();
    //this.getProductList();
    this.getNationList();
    this.getTktPassArea();
  },
  mounted() {
    // if(document.referrer == "") {
    //   this.$swal.fire('', '적절하지 않은 페이지 접근입니다.', 'error');
    //   //this.$router.push({path: '/'});
    //   location.replace("/");
    // }

    //this.scrollToSection();

    //dom이 모두 로딩 된 후, 펑션호출
    window.onload = () => {
      this.$nextTick(() => {
        this.scrollToSection();
      });
    };

  },
  computed: {
    user() {
      // 리턴정보가 바뀔 때마다 user()안에 넣어준다
      // 로그인전: bId정보없음, 로그인후: bId정보있음
      return this.$store.state.user;
    }
  },  
  methods: {
    // scrollToSection(param) {
    //   let elementId = (param === 'JP') ? 'jp' : 'no-jp';
    //   console.log("elementId:", elementId)

    //   let element = document.getElementById(elementId);

    //   if (element) {
    //     element.scrollIntoView({ behavior: 'smooth', inline:'nearest'});
    //     //element.scrollIntoView({ behavior: 'smooth', block: 'start', inline:'nearest' });
    //   }
    // },
    scrollToSection() {
      let elementId = (this.nt === 'JP') ? 'jp' : 'no-jp';
      const element = document.getElementById(elementId);
      if (element) 
      {
        const offset = 180; // 조정하고자 하는 픽셀값
        window.scrollTo({
          top: element.offsetTop - offset,
          behavior: 'smooth'
        });
      }
      // if (element) {
      //   element.scrollIntoView({ behavior: 'smooth', block: 'start', inline:'nearest' });
      // }
    },

    //앵커태그의 스크롤 위치 조정
    goToSection(id) {
      const el = document.getElementById(id)
      if (el) {
        const offset = 80
        const top = el.getBoundingClientRect().top + window.scrollY - offset
        window.scrollTo({ top, behavior: 'smooth' })
      }
    },

    async getNationList() 
    {
      let nationList = await this.$api("/api/nationList_bus", {});
      this.nationList = nationList;
      
      let natName = nationList.filter((item) => {
        return item.baseCode == this.nt
      })
      //this.natName = natName[0].codeNameKor
      this.natName = natName.codeNameKor
      //console.log("nationList:",this.nationList,",natName:",this.natName)
    },

    //선택가능한  지역정보
    async getTktPassArea() {
      let bustourArea = await this.$api("/api/getTktPassArea_new", { param: ["E"] })
      let bustourArea_etc = await this.$api("/api/getTktPassArea_etc", {param: ["E"]})

      let ntToAr = {}

      if(bustourArea.length > 0)
      {
        this.bustourArea = bustourArea
        //국가별 지역으로 정리
        bustourArea.forEach(item => {
          if(!ntToAr[item.ntCd])
          {
            ntToAr[item.ntCd] = [];
          }
          ntToAr[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR
          })
        })
      }
      this.ntToAr_jp = ntToAr

      let ntToAr_etc = {}

      if(bustourArea_etc.length > 0)
      {
        this.bustourArea_etc = bustourArea_etc
        //국가별 지역으로 정리
        bustourArea_etc.forEach(item => {
          if(!ntToAr_etc[item.ntCd])
          {
            ntToAr_etc[item.ntCd] = [];
          }
          ntToAr_etc[item.ntCd].push({
            ntCd: item.ntCd,
            arCd: item.arCd,
            NT: item.NT,
            AR: item.AR
          })
        })
      }
      this.ntToAr_etc = ntToAr_etc
    },


    // mixins에 있는 공통함수 호출샘플
    /** 자릿수 표시 */
    getCurrencyFormat(value) {
      return this.$currencyFormat(value);
    },
    /** 개행처리 */
    getStringFormat(text) {
      return this.$stringFormat(text);
    },
		/** 일자처리 */
    getDateFormat(date)
    {
      return this.$dateFormat(date);
    },

    // 상품문의
    inquiryProduct(pCode, sRoute) {
      this.$router.push({path: '/inquiryProduct', query: {productId: pCode, salesRoute:sRoute}});
    },

    // 신가격정책이 적용된 상품리스트
    async getProductList_new() 
    {
      let ntCd = this.nt
      let arCd = this.ar
      let sRoute = "E";             // 티켓패스-기타상품군
      // let sMinPrice = 0;
      // let sMargin = 0;

      //console.log("ntCd:",ntCd,"arCd:",arCd);

      // 전체로컬상품추출 후, 연계상품제외
      let productListForSales_tmptmp = await this.$api("/api/product_localtour_m", {param: [sRoute]});
      // console.log("productListForSales_tmptmp:++++ ", productListForSales_tmptmp)

      let productListForSales_tmp = productListForSales_tmptmp.filter((item) => {
        return (item.assoFlag == null || item.assoFlag == "" || item.assoFlag == undefined)
      })
      
      if(productListForSales_tmp.length > 0) 
      {
        this.productListForSales_org = productListForSales_tmp    //로컬전체상품(org)
      }
      
      // console.log("productListForSales_org: ", this.productListForSales_org)

			//엔타비상품만 추출(티켓패스는 엔타비범주)
			if(this.sellerCode === 'NT')
			{
				let productListForSales_ndaytrip1 = this.productListForSales_org.filter((item) => 
				{
					return item.sellerCode_nt == "Y";
				});

        let productListForSales_ndaytrip = productListForSales_ndaytrip1.sort((a, b) => {
          if (a.ntCd == 'JP' && b.ntCd != 'JP') 
          {
            return -1;
          } 
          else if (a.ntCd != 'JP' && b.ntCd === 'JP') 
          {
            return 1;
          } 
          else if (a.ntCd < b.ntCd) 
          {
            return -1;
          } 
          else if (a.ntCd > b.ntCd) 
          {
            return 1;
          } 
          else 
          {
            return 0;
          }
        });
        
				this.productListForSales = productListForSales_ndaytrip;
        //console.log("productListForSales: ", this.productListForSales )

        //일본내 상품
        let ndaytirpList_jp = this.productListForSales.filter(item => {
          return item.ntCd == 'JP'
        })
        //console.log("ndaytirpList_jp:",ndaytirpList_jp)
        //일본외 상품
        //let ndaytirpList_etc = [];
        let ndaytirpList_etc = this.productListForSales.filter(item => {
          return item.ntCd != 'JP'
        })
        //console.log("ndaytirpList_etc: ", ndaytirpList_etc)
        
        this.ndaytirpList_jp_org = ndaytirpList_jp.slice(0,8)
        this.ndaytirpList_jp_more = ndaytirpList_jp

        this.ndaytirpList_etc_org = ndaytirpList_etc.slice(0,8)
        this.ndaytirpList_etc_more = ndaytirpList_etc

        
        //티켓패스 전체상품
        if((ntCd == "%" || ntCd == ""))
        {
          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,8)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,8)
          return; //이후 조건에 따라 값이 배열값이 덮어써지는 것을 막는다
        }

        //일본선택
        if((ntCd == "JP" && arCd == ""))    //일본전역
        {
          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,8)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,8)
        }      
        else if(ntCd == "JP" && arCd != "")   //일본내 특정
        {
          ndaytirpList_jp = this.productListForSales.filter(item => {
            return (item.ntCd === 'JP' && item.arCd == arCd)
          })

          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,8)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,8)
        }

        //일본외 선택
        if((ntCd != "JP" && arCd == ""))    //일본외 국가
        {
          ndaytirpList_etc = this.productListForSales.filter(item => {
            return (item.ntCd == ntCd)
          })

          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,8)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,8)
        }      
        else if(ntCd != "JP" && arCd != "")   //지역특정
        {
          ndaytirpList_etc = this.productListForSales.filter(item => {
            return (item.ntCd == ntCd && item.arCd == arCd)
          })

          this.ndaytirpList_jp = ndaytirpList_jp.slice(0,8)
          this.ndaytirpList_etc = ndaytirpList_etc.slice(0,8)
        }

        //dom요소가 모두 로드된 후 펑션호출
        this.$nextTick(() => {
          this.scrollToSection(this.nt);
        });
			}
    },


    

    //일본내 상품 더보기처리
    showJpMoreList() {
      this.jp_more = (this.jp_more === 'Y') ? "N" : "Y"
      if(this.jp_more === "N")
      {
        this.ndaytirpList_jp = this.ndaytirpList_jp_org
      }
      else
      {
        this.ndaytirpList_jp = this.ndaytirpList_jp_more
      }
    },

    showJpSelArea(param) {
      if(param === 'jpAll') 
      {
        document.querySelector('.more-jp').style.display = 'block'
        document.querySelector('.more-jp').classList.add('initial-state');
        this.ndaytirpList_jp = this.ndaytirpList_jp_more
      }
      else
      {
        document.querySelector('.more-jp').style.display = "none"
        this.ndaytirpList_jp = this.ndaytirpList_jp_more.filter(item => {
          return item.arCd === param
        })
      }
    },


    //일본외 상품 더보기 처리
    showEtcMoreList() {
      this.etc_more = (this.etc_more === 'Y') ? "N" : "Y"
      if(this.etc_more === "N")
      {
        this.ndaytirpList_etc = this.ndaytirpList_etc_org
      }
      else
      {
        this.ndaytirpList_etc = this.ndaytirpList_etc_more
      }      
    },    
    showEtcSelArea(param) {
      if(param === 'etcAll') 
      {
        document.querySelector('.more-etc').style.display = 'block'
        document.querySelector('.more-etc').classList.add('initial-state');
        this.ndaytirpList_etc = this.ndaytirpList_etc_more
      }
      else
      {
        document.querySelector('.more-etc').style.display = "none"
        this.ndaytirpList_etc = this.ndaytirpList_etc_more.filter(item => {
          return item.ntCd === param
        })
      }
    },


    goToDetail(productId, salesRoute) {
      this.$router.push({path: '/detail', query: {productId: productId, salesRoute:salesRoute}});
    },
    // 숫자콤마표시
    // getCurrencyFormat(value) {
    //   // console.log('value' + value)
    //   return (value+"").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    // }
  }
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Black+Han+Sans&family=Noto+Sans+KR:wght@400;600;700;900&display=swap');
 
/* ================================================
  # CSS 변수 — #ticketpage 하위
================================================ */
#ticketpage {
  --ci-green:       #86cd53;
  --ci-green-dark:  #6ab53e;
  --ci-green-light: #e8f7dc;
  --ticket-orange:  #ff6b35;
  --ticket-yellow:  #ffd23f;
  --ticket-navy:    #1a1f3c;
  --ticket-cream:   #fefdf8;
  --charcoal:       #1c1c1c;
  --gray-100:       #f5f6f2;
  --gray-200:       #e5e7e1;
  --gray-400:       #9aa097;
  --radius-sm:      6px;
  --radius-md:      14px;
  --shadow-card:    0 6px 24px rgba(26,31,60,0.13);
  --shadow-hover:   0 16px 40px rgba(26,31,60,0.22);
 
  background: var(--ticket-cream);
  font-family: 'Noto Sans KR', sans-serif;
}
 
.fingerPointer { cursor: pointer; }
 
 
/* ================================================
  # 히어로
================================================ */
.tp-hero {
  position: relative;
  background: var(--ticket-navy);
  padding: 5rem 0 4rem;
  overflow: hidden;
  text-align: center;
}
.tp-hero-bg {
  position: absolute;
  inset: 0;
  background-image:
    radial-gradient(circle at 20% 50%, rgba(134,205,83,0.18) 0%, transparent 50%),
    radial-gradient(circle at 80% 30%, rgba(255,107,53,0.15) 0%, transparent 45%),
    radial-gradient(circle at 50% 90%, rgba(255,210,63,0.12) 0%, transparent 40%);
}
.tp-hero-dots {
  position: absolute;
  inset: 0;
  background-image: radial-gradient(circle, rgba(255,255,255,0.06) 1px, transparent 1px);
  background-size: 28px 28px;
  pointer-events: none;
}
.tp-hero-wave {
  position: absolute;
  bottom: -1px;
  left: 0;
  width: 100%;
  line-height: 0;
}
.tp-hero-wave svg { display: block; width: 100%; height: 60px; }
.tp-hero-inner { position: relative; z-index: 1; }
 
.tp-hero-tag {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 3px;
  color: var(--ci-green);
  background: rgba(134,205,83,0.12);
  border: 1px solid rgba(134,205,83,0.3);
  border-radius: 30px;
  padding: 5px 18px;
  margin-bottom: 1.2rem;
}
.tp-hero-title {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 4rem;
  letter-spacing: -2px;
  margin-bottom: 0.5rem;
  line-height: 1;
  background: linear-gradient(90deg, var(--ticket-yellow), var(--ci-green));
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}
.tp-hero-sub {
  font-size: 1rem;
  color: rgba(255,255,255,0.6);
  margin-bottom: 2rem;
}
.tp-hero-chips { display: flex; justify-content: center; gap: 12px; }
.tp-chip {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  padding: 9px 24px;
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 700;
  text-decoration: none;
  cursor: pointer;
  transition: all 0.2s;
}
.tp-chip-jp {
  background: var(--ci-green);
  color: var(--ticket-navy);
  box-shadow: 0 4px 14px rgba(134,205,83,0.4);
}
.tp-chip-etc {
  background: var(--ticket-orange);
  color: #fff;
  box-shadow: 0 4px 14px rgba(255,107,53,0.4);
}
.tp-chip:hover { transform: translateY(-2px); filter: brightness(1.1); }
 
@media (max-width: 767px) {
  .tp-hero { padding: 6rem 0 3.5rem; }
  .tp-hero-title { font-size: 2.6rem; }
}
 
 
/* ================================================
  # 섹션 공통
================================================ */
.ticketpass { background: var(--ticket-cream); padding: 0 0 5rem; }
.tp-section { padding-top: 4rem; padding-bottom: 1rem; }
 
.tp-section-header {
  text-align: center;
  margin-bottom: 1.8rem;
}
.tp-section-badge {
  display: inline-block;
  font-size: 0.65rem;
  font-weight: 900;
  letter-spacing: 5px;
  padding: 4px 16px;
  border-radius: 4px;
  margin-bottom: 0.7rem;
}
.pass-badge  { background: var(--ci-green);       color: var(--ticket-navy); }
.ticket-badge { background: var(--ticket-orange); color: #fff; }
 
.tp-section-title {
  font-family: 'Black Han Sans', sans-serif;
  font-size: 2.4rem;
  color: var(--ticket-navy);
  margin-bottom: 0.3rem;
  letter-spacing: 2px;
  display: inline-block;
}
.tp-section-title::after {
  content: '';
  display: block;
  width: 60%;
  height: 4px;
  margin: 0.3rem auto 0;
  border-radius: 2px;
  background: linear-gradient(90deg, var(--ci-green), var(--ticket-yellow));
}
.tp-section-sub {
  font-size: 0.88rem;
  color: var(--gray-400);
  margin: 0.6rem 0 0;
}
 
 
/* ================================================
  # 카테고리 필터
================================================ */
.category {
  margin: 0 0 2rem;
}
.category ul {
  padding-left: 0;
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  list-style: none;
  margin: 0;
}
.category ul li {
  padding: 7px 20px;
  border: 1.5px solid var(--gray-200);
  border-radius: 50px;
  background: #fff;
  transition: all 0.25s ease;
}
.category ul li a {
  font-size: 0.88rem;
  font-weight: 600;
  color: var(--gray-400);
  text-decoration: none;
  transition: color 0.2s;
}
.category ul li:hover {
  background: var(--ticket-navy);
  border-color: var(--ticket-navy);
}
.category ul li:hover a { color: #fff; }
 
@media (max-width: 1024px) {
  .category ul li { padding: 5px 14px; }
  .category ul li a { font-size: 0.82rem; }
}
 
 
/* ================================================
  # 섹션 구분 배너
================================================ */
.tp-divider-banner {
  background: var(--ticket-navy);
  padding: 0.9rem 0;
  overflow: hidden;
  margin: 3rem 0;
  transform: rotate(-1.2deg);
  box-shadow: 0 4px 20px rgba(26,31,60,0.2);
}
.banner-scroll-text {
  display: flex;
  white-space: nowrap;
  animation: bannerScroll 22s linear infinite;
}
.banner-scroll-text span {
  font-size: 0.88rem;
  font-weight: 700;
  letter-spacing: 1px;
  color: var(--ci-green);
  flex-shrink: 0;
}
@keyframes bannerScroll {
  0%   { transform: translateX(0); }
  100% { transform: translateX(-50%); }
}
 
 
/* ================================================
  # 상품 카드
================================================ */
.tp-card-link { text-decoration: none; display: block; }
 
.tp-card {
  background: #fff;
  border-radius: var(--radius-md);
  overflow: hidden;
  box-shadow: var(--shadow-card);
  margin-bottom: 1rem;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}
.tp-card:hover {
  transform: translateY(-6px) rotate(0.4deg);
  box-shadow: var(--shadow-hover);
}
 
/* 상단 스텁 */
.tp-card-stub {
  background: var(--ci-green);
  padding: 4px 12px;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.stub-etc  { background: var(--ticket-orange); }
.stub-text {
  font-size: 0.58rem;
  font-weight: 900;
  letter-spacing: 3px;
  color: rgba(255,255,255,0.9);
}
.stub-dots {
  font-size: 0.55rem;
  color: rgba(255,255,255,0.4);
  letter-spacing: 1px;
}
 
/* 이미지 */
.tp-card-img-wrap {
  position: relative;
  overflow: hidden;
}
.tp-card-img {
  width: 100%;
  height: 185px;
  object-fit: cover;
  display: block;
  transition: transform 0.45s ease;
}
.tp-card:hover .tp-card-img { transform: scale(1.06); }
 
/* 호버 오버레이 */
.tp-card-hover {
  position: absolute;
  inset: 0;
  background: rgba(26,31,60,0.55);
  display: flex;
  align-items: center;
  justify-content: center;
  opacity: 0;
  transition: opacity 0.3s ease;
  z-index: 2;
}
.tp-card:hover .tp-card-hover { opacity: 1; }
.tp-card-hover span {
  color: #fff;
  font-size: 0.85rem;
  font-weight: 700;
  border: 2px solid var(--ci-green);
  padding: 7px 18px;
  border-radius: 24px;
  background: rgba(134,205,83,0.18);
}
 
/* 뱃지 */
.badge-wrap { position: absolute; top: 0; left: 0; z-index: 3; }
.badge1 {
  background: #e74c3c;
  opacity: 0.88;
  padding: 8px 12px;
  border-radius: 0 0 var(--radius-sm) 0;
}
.badge1-text { color: #fff; font-size: 0.9rem; font-weight: 700; padding: 0; }
.badge2 {
  background: rgba(255,255,255,0.92);
  padding: 8px 12px;
  border-radius: 0 0 var(--radius-sm) 0;
}
.badge2-text { color: var(--ticket-navy); font-size: 0.9rem; font-weight: 700; padding: 0; }
 
/* 천공선 */
.tp-card-perf {
  border-top: 2px dashed var(--gray-200);
  margin: 0 14px;
}
.perf-etc { border-top-color: rgba(255,107,53,0.22); }
 
/* 카드 바디 */
.tp-card-body { padding: 0.75rem 1rem 1rem; }
 
.tp-card-title {
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--ticket-navy);
  line-height: 1.4;
  height: 2.52rem;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.3rem;
}
.tp-card-remarks {
  font-size: 0.75rem;
  color: var(--gray-400);
  height: 1.1rem;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
  margin-bottom: 0.5rem;
}
 
/* 가격 */
.tp-card-price {
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: 2px;
  margin-top: 0.4rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--gray-200);
}
.price-num {
  font-size: 1.2rem;
  font-weight: 900;
  color: var(--ticket-navy);
  letter-spacing: -0.5px;
}
.price-unit {
  font-size: 0.85rem;
  font-weight: 700;
  color: var(--ticket-orange);
  margin-left: 1px;
}
.price-per {
  font-size: 0.7rem;
  color: var(--gray-400);
  margin-left: 4px;
}
.price-original {
  font-size: 0.78rem;
  color: var(--gray-400);
  text-decoration: line-through;
}
.price-arrow {
  font-size: 0.85rem;
  color: var(--gray-400);
  margin: 0 2px;
}
.price-discount {
  font-size: 0.9rem;
  font-weight: 800;
  color: #e74c3c;
}
.preparing-wrap {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-top: 0.4rem;
  padding-top: 0.5rem;
  border-top: 1px solid var(--gray-200);
}
.preparing-text { font-size: 0.82rem; font-weight: 600; color: var(--gray-400); }
.mbus-icon { width: 1.5rem !important; height: auto !important; }
 
 
/* ================================================
  # 더보기 버튼
================================================ */
.more-wrap {
  display: flex;
  justify-content: center;
  margin: 2.5rem 0 1rem;
}
.more-btn {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 11px 36px;
  border: 1.5px solid var(--ci-green);
  border-radius: 50px;
  font-size: 0.9rem;
  font-weight: 700;
  color: var(--ci-green-dark);
  cursor: pointer;
  transition: all 0.25s ease;
  background: #fff;
}
.more-btn:hover {
  background: var(--ci-green);
  color: #fff;
  border-color: var(--ci-green);
}
.more-btn-etc {
  border-color: var(--ticket-orange);
  color: var(--ticket-orange);
}
.more-btn-etc:hover {
  background: var(--ticket-orange);
  color: #fff;
}
 
 
/* 모바일 */
@media (max-width: 767px) {
  .tp-card-img { height: 145px; }
  .tp-card-title { font-size: 0.82rem; }
  .price-num { font-size: 1rem; }
}
@media (max-width: 470px) {
  .tp-card-img { height: 110px; }
}
</style>